import { createRouter, createWebHistory } from "vue-router";
import { useCookies } from "vue3-cookies";
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";
import Home from "../components/caffeprint/Home.vue";
import Login from "../components/user/Login.vue";
import AdminsList from "../components/user/AdminsList.vue";
import AdminsCreate from "../components/user/AdminsCreate.vue";
import AdminBarcode from "../components/user/AdminBarcode.vue";
import GroupsList from "../components/group/GroupsList.vue";
import GroupsCreate from "../components/group/GroupsCreate.vue";
import CompetenciesList from "../components/competence/CompetenciesList.vue";
import CompetenciesCreate from "../components/competence/CompetenciesCreate.vue";
import IpsList from "../components/ip/IpsList.vue";
import IpsCreate from "../components/ip/IpsCreate.vue";
import SettingsList from "../components/setting/SettingsList.vue";
import HolidaysList from "../components/holidays/HolidaysList.vue";
import SettingsCreate from "../components/setting/SettingsCreate.vue";
import PackagesList from "../components/package/PackagesList.vue";
import PackagesCreate from "../components/package/PackagesCreate.vue";
import MachinesList from "../components/machines/MachinesList.vue";
import MachinesEdit from "../components/machines/MachinesEdit.vue";
import MachinesCreate from "../components/machines/MachinesCreate.vue";
import ProcessesList from "../components/processes/ProcessesList.vue";
import ProcessesCreate from "../components/processes/ProcessesCreate.vue";
import PlatesList from "../components/plates/PlatesList.vue";
import PlatesCreate from "../components/plates/PlatesCreate.vue";
import VariablesList from "../components/variables/VariablesList.vue";
import SalelogsList from "../components/logs/SaleLogsList.vue";
import SystemlogsList from "../components/logs/SystemlogsList.vue";
import ProductionlogsList from "../components/logs/ProductionlogsList.vue";
import MontagelogsList from "../components/logs/MontageLogsList.vue";
import CubelogsList from "../components/logs/CubeLogsList.vue";
import OverallLogsList from "../components/logs/OverallLogsList.vue";
import ProductLogsList from "../components/logs/ProductLogsList.vue";
import PackageLogsList from "../components/logs/PackageLogsList.vue";
import NewsList from "../components/news/NewsList.vue";
import NewsCreate from "../components/news/NewsCreate.vue";
import BannersList from "../components/banner/BannersList.vue";
import BannersCreate from "../components/banner/BannersCreate.vue";
import PagesList from "../components/pages/PagesList.vue";
import PagesCreate from "../components/pages/PagesCreate.vue";
import FaqCreate from "../components/faq/FaqCreate.vue";
import FaqList from "../components/faq/FaqList.vue";
import TranslationsList from "../components/translations/TranslationsList.vue";
import TranslationsModelsList from "../components/translations/TranslationsModelsList.vue";
import I18nTranslationsList from "../components/translations/I18nTranslationsList.vue";
import FilesList from "../components/file/FilesList.vue";
import FilesCreate from "../components/file/FilesCreate.vue";
import CategoriesList from "../components/categories/CategoriesList.vue";
import CategoriesCreate from "../components/categories/CategoriesCreate.vue";
import ProductsList from "../components/product/ProductsList.vue";
import ProductsCreate from "../components/product/ProductsCreate.vue";
import ProductsEdit from "../components/product/ProductsEdit.vue";
import ParametersList from "../components/parameters/ParametersList.vue";
import ParametersCreate from "../components/parameters/ParametersCreate.vue";
import FormatGroupCreate from "../components/format-group/FormatGroupCreate.vue";
import FormatGroupList from "../components/format-group/FormatGroupList.vue";
import FormatGroupEdit from "../components/format-group/FormatGroupEdit.vue";
import FormatList from "../components/format/FormatList.vue";
import FormatCreate from "../components/format/FormatCreate.vue";
import ProductOptionGroupCreate from "../components/product-option-group/ProductOptionGroupCreate.vue";
import ProductOptionList from "../components/product-option-group/ProductOptionList.vue";
import ProductOptionExCreate from "../components/product-option-exclusion/ProductOptionExCreate.vue";
import ProductOptionExList from "../components/product-option-exclusion/ProductOptionExList.vue";
import ProductOptionsInGroup from "../components/product-option-group/ProductOptionsInGroup.vue";
import ProductOptionEdit from "../components/product-option-group/ProductOptionEdit.vue";
import ProductOptionCreate from "../components/product-option-group/ProductOptionCreate.vue";
import AppliancesList from "../components/appliances/AppliancesList.vue";
import AppliancesCreate from "../components/appliances/AppliancesCreate.vue";
import MontagesList from "../components/montages/MontagesList.vue";
import MontagesCreate from "../components/montages/MontagesCreate.vue";
import MontagesEdit from "../components/montages/MontagesEdit.vue";
import MontagesArchList from "../components/montages/MontagesArchList.vue";
import OrderSend from "../components/order/Send.vue";
import OrderCreate from "../components/order/OrderCreate.vue";
import OrderList from "../components/order/OrderList.vue";
import OrderDetails from "../components/order/OrderDetails.vue";
import OrderPacking from "../components/order/Packing.vue";
import CubesList from "../components/cubes/CubesList.vue";
import CubeDetails from "../components/cubes/CubeDetails.vue";
import ClientsList from "../components/clients/ClientsList.vue";
import ClientsDetails from "../components/clients/ClientsDetails.vue";
import ClientsCreate from "../components/clients/ClientsCreate.vue";
import DiscountGroupsList from "../components/discount-groups/DiscountGroupsList.vue";
import DiscountGroupsCreate from "../components/discount-groups/DiscountGroupsCreate.vue";
import MessagesList from "../components/messages/MessagesList.vue";
import MessagesDetails from "../components/messages/MessagesDetails.vue";
import MessagesCreate from "../components/messages/MessagesCreate.vue";
import DiscountList from "../components/discount/DiscountList.vue";
import InvoicesList from "../components/invoices/InvoicesList.vue";
import LegacyInvoicesList from "../components/invoices/LegacyInvoicesList.vue";
import PaymentImport from "../components/payment/PaymentImport.vue";
import OffersCreate from "../components/allegro/OffersCreate.vue";
import OffersEdit from "../components/allegro/OffersEdit.vue";
import ThreadDetails from "../components/allegro/ThreadDetails.vue";
import AccountsList from "../components/allegro/AccountsList.vue";
import AccountCreate from "../components/allegro/AccountCreate.vue";
import AccountUpdate from "../components/allegro/AccountUpdate.vue";
import AccountOverview from "../components/allegro/AccountOverview.vue";
import AccountSettings from "../components/allegro/AccountSettings.vue";
import AccountOffers from "../components/allegro/AccountOffers.vue";
import AccountThreads from "../components/allegro/AccountThreads.vue";
import OauthCreate from "../components/allegro/OauthCreate.vue";
import OauthUpdate from "../components/allegro/OauthUpdate.vue";
import SellerCreate from "../components/allegro/SellerCreate.vue";
import SellerUpdate from "../components/allegro/SellerUpdate.vue";
import SenderCreate from "../components/allegro/SenderCreate.vue";
import SenderUpdate from "../components/allegro/SenderUpdate.vue";
import CodReceiverCreate from "../components/allegro/CodReceiverCreate.vue";
import CodReceiverUpdate from "../components/allegro/CodReceiverUpdate.vue";
import ResponsibleProducerCreate from "../components/allegro/ResponsibleProducerCreate.vue";
import ResponsibleProducerUpdate from "../components/allegro/ResponsibleProducerUpdate.vue";
import SafetyInformationCreate from "../components/allegro/SafetyInformationCreate.vue";
import SafetyInformationUpdate from "../components/allegro/SafetyInformationUpdate.vue";
import TrackingTagsList from "../components/tracking-tags/TrackingTagsList.vue";
import TrackingTagsCreate from "../components/tracking-tags/TrackingTagsCreate.vue";
import DynamicPrices from "../components/dynamic-prices/DynamicPrices.vue";
import CostsList from "../components/costs/CostsList.vue";
import CostsCreate from "../components/costs/CostsCreate.vue";
import KsefCompaniesList from "../components/ksef/KsefCompaniesList.vue";
import KsefCompanyCreate from "../components/ksef/KsefCompanyCreate.vue";
import KsefCompanyUpdate from "../components/ksef/KsefCompanyUpdate.vue";
import KsefCompanyDetail from "../components/ksef/KsefCompanyDetail.vue";
import KsefCompanyCertCreate from "../components/ksef/KsefCompanyCertCreate.vue";
import {
  ksefCompanyPermissionsConst,
  ksefCertificatePermissionsConst,
} from "../constants/ksefConstants";
import {
  invoicePermissionsConst,
  orderPermissionsConst,
  paymentImportPermissionsConst,
} from "../constants/orderConstants";
import { modelPermissionsGroupPermissionsConst } from "../constants/groupConstants";
import { adminPermissionsConst } from "../constants/userConstants";
import { clientPermissionsConst } from "../constants/clientConstants";
import { allowedIpPermissionsConst } from "../constants/ipConstants";
import { discountGroupPermissionsConst } from "../constants/discountGroupConstants";
import {
  bannerPermissionsConst,
  clientcontactPermissionsConst,
  faqPermissionsConst,
  settingPermissionsConst,
  systemLogPermissionsConst,
  variablePermissionsConst,
} from "../constants/settingConstants";
import { newsPermissionsConst } from "../constants/newsConstants";
import { costPermissionsConst } from "../constants/costConstants";
import { trackingTagPermissionsConst } from "../constants/tagsConstants";
import {
  appliancesPermissionsConst,
  competencePermissionsConst,
  holidayPermissionsConst,
  machinePermissionsConst,
  montagePermissionsConst,
  platePermissionsConst,
} from "../constants/productionConstants";
import {
  categoryPermissionsConst,
  discountPermissionsConst,
  exclusionPermissionsConst,
  packagePermissionsConst,
  productOptionGroupPermissionsConst,
  productOptionPermissionsConst,
  productParameterPermissionsConst,
  productPermissionsConst,
  turnoverDiscountSettingPermissionsConst,
} from "../constants/productConstants";
import {
  formatGroupPermissionsConst,
  formatPermissionsConst,
} from "../constants/formatConstants";
import { pagePermissionsConst } from "../constants/pageConstants";
import { statsPermissionsConst } from "../constants/statsConstants";
import {
  allegroAccountPermissionsConst,
  allegroConfigPermissionsConst,
  allegroOfferPermissionsConst,
  allegroSellerPermissionsConst,
  allegroSenderPermissionsConst,
  allegroCodReceiverPermissionsConst,
  allegroResponsibleProducerPermissionsConst,
  allegroSafetyInformationPermissionsConst,
  allegroThreadPermissionsConst,
} from "../constants/allegroConstants";
import { filePermissionsConst } from "../constants/fileConstants";
import {
  processPermissionsConst,
  processStagePermissionsConst,
} from "../constants/processConstants";
import {
  translationPermissionsConst,
  i18nTranslationPermissionsConst,
} from "../constants/translationConstants";
import { ensureUser, isDenied } from "../permissions";

const { cookies } = useCookies();
const routerHistory = createWebHistory();
const router = createRouter({
  history: routerHistory,
  routes: [
    {
      path: "/",
      component: Home,
      name: "Home",
    },
    {
      path: "/dynamic-prices",
      name: "DynamicPrices",
      component: DynamicPrices,
      meta: { modelPermission: turnoverDiscountSettingPermissionsConst.view },
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
    },
    {
      path: "/admins/:pk?",
      name: "Admins",
      component: AdminsList,
      meta: { modelPermission: adminPermissionsConst.view },
    },
    {
      path: "/admins/create",
      name: "AdminsCreate",
      component: AdminsCreate,
      meta: { modelPermission: adminPermissionsConst.add },
    },
    {
      path: "/admins/update",
      name: "AdminsUpdate",
      component: AdminsCreate,
      meta: { modelPermission: adminPermissionsConst.update },
    },
    {
      path: "/admins/:id/barcode",
      name: "AdminBarcode",
      component: AdminBarcode,
    },
    {
      path: "/groups",
      name: "Groups",
      component: GroupsList,
      meta: { modelPermission: modelPermissionsGroupPermissionsConst.view },
    },
    {
      path: "/groups/create",
      name: "GroupsCreate",
      component: GroupsCreate,
      meta: { modelPermission: modelPermissionsGroupPermissionsConst.add },
    },
    {
      path: "/competencies",
      name: "Competencies",
      component: CompetenciesList,
      meta: { modelPermission: competencePermissionsConst.view },
    },
    {
      path: "/competencies/create",
      name: "CompetenciesCreate",
      component: CompetenciesCreate,
      meta: { modelPermission: competencePermissionsConst.add },
    },
    {
      path: "/ips",
      name: "Ips",
      component: IpsList,
      meta: {
        modelPermission: allowedIpPermissionsConst.view,
      },
    },
    {
      path: "/ips/create",
      name: "IpsCreate",
      component: IpsCreate,
      meta: {
        modelPermission: allowedIpPermissionsConst.add,
      },
    },
    {
      path: "/settings",
      name: "Settings",
      component: SettingsList,
      meta: {
        modelPermission: settingPermissionsConst.view,
      },
    },
    {
      path: "/settings/create",
      name: "SettingsCreate",
      component: SettingsCreate,
      meta: {
        modelPermission: settingPermissionsConst.add,
      },
    },
    {
      path: "/holidays",
      name: "HolidaysList",
      component: HolidaysList,
      meta: { modelPermission: holidayPermissionsConst.view },
    },
    {
      path: "/packages",
      name: "PackagesList",
      component: PackagesList,
      meta: { modelPermission: packagePermissionsConst.view },
    },
    {
      path: "/packages/create",
      name: "PackagesCreate",
      component: PackagesCreate,
      meta: { modelPermission: packagePermissionsConst.add },
    },
    {
      path: "/machines",
      name: "MachinesList",
      component: MachinesList,
      meta: { modelPermission: machinePermissionsConst.view },
    },
    {
      path: "/machines/create",
      name: "MachinesCreate",
      component: MachinesCreate,
      meta: { modelPermission: machinePermissionsConst.add },
    },
    {
      path: "/machines/edit/:pk",
      name: "MachinesEdit",
      component: MachinesEdit,
      meta: { modelPermission: machinePermissionsConst.update },
    },
    {
      path: "/processes",
      name: "ProcessesList",
      component: ProcessesList,
      meta: { modelPermission: processPermissionsConst.view },
    },
    {
      path: "/processes/create",
      name: "ProcessesCreate",
      component: ProcessesCreate,
      meta: { modelPermission: processPermissionsConst.add },
    },
    {
      path: "/plates",
      name: "PlatesList",
      component: PlatesList,
      meta: { modelPermission: platePermissionsConst.view },
    },
    {
      path: "/plates/create",
      name: "PlatesCreate",
      component: PlatesCreate,
      meta: { modelPermission: platePermissionsConst.add },
    },
    {
      path: "/variables",
      name: "VariablesList",
      component: VariablesList,
      meta: {
        modelPermission: variablePermissionsConst.view,
      },
    },
    {
      path: "/systemlogs",
      name: "SystemlogsList",
      component: SystemlogsList,
      meta: {
        modelPermission: systemLogPermissionsConst.view,
      },
    },
    {
      path: "/productionlogs",
      name: "ProductionlogsList",
      component: ProductionlogsList,
      meta: {
        modelPermission: statsPermissionsConst.productionLogs,
      },
    },
    {
      path: "/montagelogs",
      name: "MontagelogsList",
      component: MontagelogsList,
      meta: {
        modelPermission: statsPermissionsConst.view,
      },
    },
    {
      path: "/cubelogs",
      name: "CubelogsList",
      component: CubelogsList,
      meta: {
        modelPermission: statsPermissionsConst.view,
      },
    },
    {
      path: "/overall",
      name: "OverallLogsList",
      component: OverallLogsList,
      meta: {
        modelPermission: statsPermissionsConst.view,
      },
    },
    {
      path: "/productlogs",
      name: "ProductLogsList",
      component: ProductLogsList,
      meta: {
        modelPermission: statsPermissionsConst.view,
      },
    },
    {
      path: "/salelogs",
      name: "SalelogsList",
      component: SalelogsList,
      meta: {
        modelPermission: statsPermissionsConst.view,
      },
    },
    {
      path: "/packagelogs",
      name: "PackageLogsList",
      component: PackageLogsList,
      meta: {
        modelPermission: statsPermissionsConst.view,
      },
    },
    {
      path: "/news/list",
      name: "NewsList",
      component: NewsList,
      meta: { modelPermission: newsPermissionsConst.view },
    },
    {
      path: "/news/create",
      name: "NewsCreate",
      component: NewsCreate,
      meta: { modelPermission: newsPermissionsConst.add },
    },
    {
      path: "/banners/list",
      name: "BannersList",
      component: BannersList,
      meta: { modelPermission: bannerPermissionsConst.view },
    },
    {
      path: "/banners/create",
      name: "BannersCreate",
      component: BannersCreate,
      meta: { modelPermission: bannerPermissionsConst.add },
    },
    {
      path: "/pages",
      name: "PagesList",
      component: PagesList,
      meta: { modelPermission: pagePermissionsConst.view },
    },
    {
      path: "/pages/create",
      name: "PagesCreate",
      component: PagesCreate,
      meta: { modelPermission: pagePermissionsConst.add },
    },
    {
      path: "/pages/edit/:pk",
      name: "PagesEdit",
      component: PagesCreate,
      meta: { modelPermission: pagePermissionsConst.update },
    },
    {
      path: "/faq/create",
      name: "FaqCreate",
      component: FaqCreate,
      meta: { modelPermission: faqPermissionsConst.add },
    },
    {
      path: "/faq",
      name: "FaqList",
      component: FaqList,
      meta: { modelPermission: faqPermissionsConst.view },
    },
    {
      path: "/translations",
      name: "TranslationsList",
      component: TranslationsList,
      meta: { modelPermission: translationPermissionsConst.view },
    },
    {
      path: "/i18n/translations",
      name: "I18nTranslationsList",
      component: I18nTranslationsList,
      meta: { modelPermission: i18nTranslationPermissionsConst.view },
    },
    {
      path: "/translations/models-list",
      name: "TranslationsModelsList",
      component: TranslationsModelsList,
      meta: { modelPermission: translationPermissionsConst.view },
    },
    {
      path: "/file/list",
      name: "FilesList",
      component: FilesList,
      meta: { modelPermission: filePermissionsConst.view },
    },
    {
      path: "/file/create",
      name: "FilesCreate",
      component: FilesCreate,
      meta: { modelPermission: filePermissionsConst.add },
    },
    {
      path: "/categories/list",
      name: "CategoriesList",
      component: CategoriesList,
      meta: { modelPermission: categoryPermissionsConst.view },
    },
    {
      path: "/categories/create",
      name: "CategoriesCreate",
      component: CategoriesCreate,
      meta: { modelPermission: categoryPermissionsConst.add },
    },
    {
      path: "/products/create",
      name: "ProductsCreate",
      component: ProductsCreate,
      meta: { modelPermission: productPermissionsConst.add },
    },
    {
      path: "/products",
      name: "ProductsList",
      component: ProductsList,
      meta: { modelPermission: productPermissionsConst.view },
    },
    {
      path: "/products/edit/:pk",
      name: "ProductsEdit",
      component: ProductsEdit,
      meta: { modelPermission: productPermissionsConst.update },
    },
    {
      path: "/parameters/create",
      name: "ParametersCreate",
      component: ParametersCreate,
      meta: { modelPermission: productParameterPermissionsConst.add },
    },
    {
      path: "/parameters",
      name: "ParametersList",
      component: ParametersList,
      meta: { modelPermission: productParameterPermissionsConst.view },
    },
    {
      path: "/format-groups",
      name: "FormatGroupsList",
      component: FormatGroupList,
      meta: { modelPermission: formatGroupPermissionsConst.view },
    },
    {
      path: "/format-groups/create",
      name: "FormatGroupCreate",
      component: FormatGroupCreate,
      meta: { modelPermission: formatGroupPermissionsConst.add },
    },
    {
      path: "/format-groups/edit/:pk",
      name: "FormatGroupEdit",
      component: FormatGroupEdit,
      meta: { modelPermission: formatGroupPermissionsConst.update },
    },
    {
      path: "/format/list",
      name: "FormatsList",
      component: FormatList,
      meta: { modelPermission: formatPermissionsConst.view },
    },
    {
      path: "/format/create",
      name: "FormatCreate",
      component: FormatCreate,
      meta: { modelPermission: formatPermissionsConst.add },
    },
    {
      path: "/product-option-group/list",
      name: "ProductOptionList",
      component: ProductOptionList,
      meta: { modelPermission: productOptionGroupPermissionsConst.view },
    },
    {
      path: "/product-option-group/:group_pk/options",
      name: "ProductOptionsInGroup",
      component: ProductOptionsInGroup,
      meta: { modelPermission: productOptionPermissionsConst.view },
    },
    {
      path: "/product-option-group/create",
      name: "ProductOptionGroupCreate",
      component: ProductOptionGroupCreate,
      meta: { modelPermission: productOptionGroupPermissionsConst.add },
    },
    {
      path: "/product-option-group/:group_pk/option/create",
      name: "ProductOptionCreate",
      component: ProductOptionCreate,
      meta: { modelPermission: productOptionPermissionsConst.add },
    },
    {
      path: "/product-option-group/:group_pk/option/:option_pk/edit",
      name: "ProductOptionEdit",
      component: ProductOptionEdit,
      meta: { modelPermission: productOptionPermissionsConst.update },
    },
    {
      path: "/product-option-exclusion/list",
      name: "ProductOptionExList",
      component: ProductOptionExList,
      meta: { modelPermission: exclusionPermissionsConst.view },
    },
    {
      path: "/product-option-exclusion/create",
      name: "ProductOptionExCreate",
      component: ProductOptionExCreate,
      meta: { modelPermission: exclusionPermissionsConst.add },
    },
    {
      path: "/appliances",
      name: "AppliancesList",
      component: AppliancesList,
      meta: { modelPermission: appliancesPermissionsConst.view },
    },
    {
      path: "/appliances/create",
      name: "AppliancesCreate",
      component: AppliancesCreate,
      meta: { modelPermission: appliancesPermissionsConst.add },
    },
    {
      path: "/montages/list",
      name: "MontagesList",
      component: MontagesList,
      meta: { modelPermission: montagePermissionsConst.view },
    },
    {
      path: "/montages/create",
      name: "MontagesCreate",
      component: MontagesCreate,
      meta: { modelPermission: montagePermissionsConst.add },
    },
    {
      path: "/montages/edit/:pk",
      name: "MontagesEdit",
      component: MontagesEdit,
      meta: { modelPermission: montagePermissionsConst.view },
    },
    {
      path: "/montages/list-archive",
      name: "MontagesArchList",
      component: MontagesArchList,
      meta: { modelPermission: montagePermissionsConst.view },
    },
    {
      path: "/order/send",
      name: "OrderSend",
      component: OrderSend,
      meta: { modelPermission: orderPermissionsConst.send },
    },
    {
      path: "/order/create",
      name: "OrderCreate",
      component: OrderCreate,
      meta: { modelPermission: orderPermissionsConst.add },
    },
    {
      path: "/order/list",
      name: "OrderList",
      component: OrderList,
      meta: { modelPermission: orderPermissionsConst.view },
    },
    {
      path: "/order/send/:pk",
      name: "OrderPacking",
      component: OrderPacking,
      meta: { modelPermission: orderPermissionsConst.send },
    },
    {
      path: "/order/details/:pk",
      name: "OrderDetails",
      component: OrderDetails,
      meta: { modelPermission: orderPermissionsConst.view },
    },
    {
      path: "/cubes/list",
      name: "CubesList",
      component: CubesList,
      meta: { modelPermission: processStagePermissionsConst.view },
    },
    {
      path: "/cubes/details/:pk",
      name: "CubeDetails",
      component: CubeDetails,
      meta: { modelPermission: processStagePermissionsConst.view },
    },
    {
      path: "/clients/:pk",
      name: "ClientsDetails",
      component: ClientsDetails,
      meta: { modelPermission: clientPermissionsConst.view },
    },
    {
      path: "/clients/list",
      name: "ClientsList",
      component: ClientsList,
      meta: { modelPermission: clientPermissionsConst.view },
    },
    {
      path: "/clients/create",
      name: "ClientsCreate",
      component: ClientsCreate,
      meta: { modelPermission: clientPermissionsConst.add },
    },
    {
      path: "/discount-groups/list",
      name: "DiscountGroupsList",
      component: DiscountGroupsList,
      meta: {
        modelPermission: discountGroupPermissionsConst.view,
      },
    },
    {
      path: "/discount/list",
      name: "DiscountList",
      component: DiscountList,
      meta: { modelPermission: discountPermissionsConst.view },
    },
    {
      path: "/discount-groups/create",
      name: "DiscountGroupsCreate",
      component: DiscountGroupsCreate,
      meta: {
        modelPermission: discountGroupPermissionsConst.add,
      },
    },
    {
      path: "/messages/list",
      name: "MessagesList",
      component: MessagesList,
      meta: { modelPermission: clientcontactPermissionsConst.view },
    },
    {
      path: "/messages/details/:pk",
      name: "MessagesDetails",
      component: MessagesDetails,
      // The details view is the case edit form - the old panel routes it as
      // layout.messages.update.
      meta: { modelPermission: clientcontactPermissionsConst.update },
    },
    {
      path: "/allegro/offers/update/:pk",
      name: "OffersEdit",
      component: OffersEdit,
      meta: { modelPermission: allegroOfferPermissionsConst.update },
    },
    {
      path: "/messages/create",
      name: "MessagesCreate",
      component: MessagesCreate,
      meta: { modelPermission: clientcontactPermissionsConst.add },
    },
    {
      path: "/invoices/list",
      name: "InvoicesList",
      component: InvoicesList,
      meta: { modelPermission: invoicePermissionsConst.view },
    },
    {
      path: "/invoices/legacy_list",
      name: "LegacyInvoicesList",
      component: LegacyInvoicesList,
      meta: { modelPermission: invoicePermissionsConst.view },
    },
    {
      path: "/payment/import",
      name: "PaymentImport",
      component: PaymentImport,
      meta: { modelPermission: paymentImportPermissionsConst.view },
    },
    {
      path: "/allegro/threads/:pk",
      name: "AllegroThreadDetails",
      component: ThreadDetails,
      meta: { modelPermission: allegroThreadPermissionsConst.view },
    },
    {
      path: "/allegro/accounts/list",
      name: "AllegroAccountsList",
      component: AccountsList,
      meta: { modelPermission: allegroAccountPermissionsConst.view },
    },
    {
      path: "/allegro/accounts",
      redirect: "/allegro/accounts/list",
    },
    {
      path: "/allegro/accounts/create",
      name: "AllegroAccountCreate",
      component: AccountCreate,
      meta: { modelPermission: allegroAccountPermissionsConst.add },
    },
    {
      path: "/allegro/accounts/:pk/update",
      name: "AllegroAccountUpdate",
      component: AccountUpdate,
      meta: { modelPermission: allegroAccountPermissionsConst.update },
    },
    {
      path: "/allegro/accounts/:pk",
      redirect: (to) => `/allegro/accounts/${to.params.pk}/overview`,
    },
    {
      path: "/allegro/accounts/:pk/overview",
      name: "AllegroAccountOverview",
      component: AccountOverview,
      meta: { modelPermission: allegroAccountPermissionsConst.view },
    },
    {
      path: "/allegro/accounts/:pk/settings",
      name: "AllegroAccountSettings",
      component: AccountSettings,
      meta: { modelPermission: allegroAccountPermissionsConst.view },
    },
    {
      path: "/allegro/accounts/:pk/offers",
      name: "AllegroAccountOffers",
      component: AccountOffers,
      meta: { modelPermission: allegroOfferPermissionsConst.view },
    },
    {
      path: "/allegro/accounts/:pk/threads",
      name: "AllegroAccountThreads",
      component: AccountThreads,
      meta: { modelPermission: allegroThreadPermissionsConst.view },
    },
    {
      path: "/allegro/accounts/:pk/oauth/create",
      name: "AllegroOauthCreate",
      component: OauthCreate,
      meta: { modelPermission: allegroConfigPermissionsConst.add },
    },
    {
      path: "/allegro/oauth/:pk/update",
      name: "AllegroOauthUpdate",
      component: OauthUpdate,
      meta: { modelPermission: allegroConfigPermissionsConst.update },
    },
    {
      path: "/allegro/accounts/:pk/offer/create",
      name: "AllegroAccountOfferCreate",
      component: OffersCreate,
      meta: { modelPermission: allegroOfferPermissionsConst.add },
    },
    {
      path: "/allegro/accounts/:pk/seller/create",
      name: "AllegroSellerCreate",
      component: SellerCreate,
      meta: { modelPermission: allegroSellerPermissionsConst.add },
    },
    {
      path: "/allegro/sellers/:pk/update",
      name: "AllegroSellerUpdate",
      component: SellerUpdate,
      meta: { modelPermission: allegroSellerPermissionsConst.update },
    },
    {
      path: "/allegro/accounts/:pk/sender/create",
      name: "AllegroSenderCreate",
      component: SenderCreate,
      meta: { modelPermission: allegroSenderPermissionsConst.add },
    },
    {
      path: "/allegro/senders/:pk/update",
      name: "AllegroSenderUpdate",
      component: SenderUpdate,
      meta: { modelPermission: allegroSenderPermissionsConst.update },
    },
    {
      path: "/allegro/accounts/:pk/cod-receiver/create",
      name: "AllegroCodReceiverCreate",
      component: CodReceiverCreate,
      meta: { modelPermission: allegroCodReceiverPermissionsConst.add },
    },
    {
      path: "/allegro/cod-receivers/:pk/update",
      name: "AllegroCodReceiverUpdate",
      component: CodReceiverUpdate,
      meta: { modelPermission: allegroCodReceiverPermissionsConst.update },
    },
    {
      path: "/allegro/accounts/:pk/responsible-producer/create",
      name: "AllegroResponsibleProducerCreate",
      component: ResponsibleProducerCreate,
      meta: { modelPermission: allegroResponsibleProducerPermissionsConst.add },
    },
    {
      path: "/allegro/responsible-producers/:pk/update",
      name: "AllegroResponsibleProducerUpdate",
      component: ResponsibleProducerUpdate,
      meta: {
        modelPermission: allegroResponsibleProducerPermissionsConst.update,
      },
    },
    {
      path: "/allegro/accounts/:pk/safety-information/create",
      name: "AllegroSafetyInformationCreate",
      component: SafetyInformationCreate,
      meta: { modelPermission: allegroSafetyInformationPermissionsConst.add },
    },
    {
      path: "/allegro/product-safety-informations/:pk/update",
      name: "AllegroSafetyInformationUpdate",
      component: SafetyInformationUpdate,
      meta: {
        modelPermission: allegroSafetyInformationPermissionsConst.update,
      },
    },
    {
      path: "/tracking-tags",
      name: "TrackingTagsList",
      component: TrackingTagsList,
      meta: { modelPermission: trackingTagPermissionsConst.view },
    },
    {
      path: "/tracking-tags/create",
      name: "TrackingTagsCreate",
      component: TrackingTagsCreate,
      meta: { modelPermission: trackingTagPermissionsConst.add },
    },
    {
      path: "/costs",
      name: "CostsList",
      component: CostsList,
      meta: { modelPermission: costPermissionsConst.view },
    },
    {
      path: "/costs/create",
      name: "CostsCreate",
      component: CostsCreate,
      meta: { modelPermission: costPermissionsConst.add },
    },
    {
      path: "/costs/edit/:pk",
      name: "CostsEdit",
      component: CostsCreate,
      meta: { modelPermission: costPermissionsConst.update },
    },
    {
      path: "/ksef/companies",
      name: "KsefCompaniesList",
      component: KsefCompaniesList,
      meta: { modelPermission: ksefCompanyPermissionsConst.view },
    },
    {
      path: "/ksef/companies/create",
      name: "KsefCompanyCreate",
      component: KsefCompanyCreate,
      meta: { modelPermission: ksefCompanyPermissionsConst.add },
    },
    {
      path: "/ksef/companies/:pk",
      name: "KsefCompanyDetail",
      component: KsefCompanyDetail,
      meta: { modelPermission: ksefCompanyPermissionsConst.view },
    },
    {
      path: "/ksef/companies/:pk/update",
      name: "KsefCompanyUpdate",
      component: KsefCompanyUpdate,
      meta: { modelPermission: ksefCompanyPermissionsConst.update },
    },
    {
      path: "/ksef/companies/:pk/create-cert",
      name: "KsefCompanyCertCreate",
      component: KsefCompanyCertCreate,
      meta: { modelPermission: ksefCertificatePermissionsConst.add },
    },
  ],
  scrollBehavior() {
    return { top: 0 };
  },
});

router.beforeEach(async (to, from, next) => {
  var isLogged = cookies.get("CPsession");
  if (!isLogged && to.name !== "Login") {
    next("/login");
    return;
  }

  if (isLogged) {
    // The logged in user data (permissions) must be available before the
    // component renders - hasPermission() works synchronously.
    await ensureUser();
  }

  const modelPermission = to.meta?.modelPermission;

  if (modelPermission) {
    if (isDenied(modelPermission)) {
      toast(modelPermission.errorMsg, {
        theme: "colored",
        autoClose: "",
        type: "error",
        dangerouslyHTMLString: true,
      });
      next("/");
      return;
    }
  }

  next();
});

export default router;
